import { render, staticRenderFns } from "./PatologiaFormulario.vue?vue&type=template&id=fad061c6"
import script from "./PatologiaFormulario.vue?vue&type=script&lang=js"
export * from "./PatologiaFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports